import Switch from '../Common/Switch';

const SwitchInputWrapper = objProps => {
  return <Switch {...objProps.field} {...objProps} />;
};

export default SwitchInputWrapper;
